<template>
  <button v-if="$props.loading" class="asyc-button">
    <font-awesome-icon icon="spinner" pulse aria-label="Loading..." />
  </button>
  <button
    v-else
    class="icon-dropdown"
    @click="toggleColumnMenu"
    v-click-outside="hideColumnMenu"
    :disabled="$props.disabled"
  >
    <font-awesome-icon icon="caret-down" aria-label="Select item" />
    {{ $props.title }}
    <ul ref="menu" class="dropdown hide">
      <slot />
    </ul>
  </button>
</template>

<script>
  import dropdownable from '@mixins/dropdownable'
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    mixins: [dropdownable],
    components: {
      FontAwesomeIcon
    },
    props: {
      title: String,
      loading: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    }
  }
</script>
